import { create } from "./resettable-store";
import { devtools, persist } from "zustand/middleware";

export interface ManagementState {
  previousGymPath: string | null;
  previousManagementPath: string | null;
  setPreviousGymPath: (path: string) => void;
  setPreviousManagementPath: (path: string) => void;
}

export const useManagementStore = create<ManagementState>()(
  devtools(
    persist(
      (set) => ({
        previousGymPath: null,
        previousManagementPath: null,

        setPreviousGymPath: (path: string) =>
          set({ previousGymPath: path }, false, "setPreviousGymPath"),

        setPreviousManagementPath: (path: string) =>
          set(
            { previousManagementPath: path },
            false,
            "setPreviousManagementPath",
          ),
      }),
      {
        name: "management-storage",
      },
    ),
    { name: "management-store" },
  ),
);
